module.exports = __webpack_public_path__ + "static/media/11.e812a6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/biquad/11.png
// module id = 1532
// module chunks = 0